module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABjSURBVHgBjZDbCcAgEASXpIKUkMqSzs4S0kJKSgVmP1RE7+HBiMgMHALARQTxSHGRSA4iKU6qD140yV5kyloUymOkypsSZOOuTr9Gv14oj+vJimxGK7/Rop3HQT5yO8FDTvL+uYouEq/mbZIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/back2.png
// module id = wYbB
// module chunks = 36